import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { onMounted, watch, ref } from "vue";
import { useContactStore } from "@/store/contact"; //引入news仓库

import { useRouter, useRoute } from "vue-router";
export default {
  name: "App",
  components: {
    Header: Header,
    Footer: Footer
  },
  setup: function setup() {
    var router = useRouter();
    var route = useRoute();
    var showCompoents = ref(true); //控制搜索框显示隐藏

    watch(function () {
      // console.log('route=', route.path)
      // console.log('route=',route.path /mediaDetails);
      if (route.path == '/legalNotice') {
        showCompoents.value = false;
      } else {
        showCompoents.value = true;
      }
    });
    var store = useContactStore();
    onMounted(function () {
      var token = localStorage.getItem('token');

      if (!token) {
        store.getToken(); //获取token
      } // window.onload = function () {
      //   if (window.innerWidth <= 1380) {
      //     const elements = document.querySelectorAll('*')
      //     console.log('elements=', elements)
      //     elements.forEach(element => {
      //       const styles = element.style
      //       const width = styles.width
      //       if (width) {
      //         const num = parseFloat(width)
      //         if (!isNaN(num)) {
      //           styles.width = num * 0.75 + 'px'
      //         }
      //       }
      //       // 处理高度
      //       const height = styles.height
      //       if (height) {
      //         const num = parseFloat(height)
      //         if (!isNaN(num)) {
      //           styles.height = num * 0.75 + 'px'
      //         }
      //       }
      //       // 处理字体大小
      //       const fontSize = styles.fontSize
      //       if (fontSize) {
      //         const num = parseFloat(fontSize)
      //         if (!isNaN(num)) {
      //           styles.fontSize = num * 0.75 + 'px'
      //         }
      //       }
      //       // 处理外边距（分别处理四个方向，这里简化只考虑了margin属性整体的情况，如需精确到各个方向可进一步细分处理marginLeft、marginTop等）
      //       const margin = styles.margin
      //       if (margin) {
      //         const num = parseFloat(margin)
      //         if (!isNaN(num)) {
      //           styles.margin = num * 0.75 + 'px'
      //         }
      //       }
      //       // 处理内边距（同样简化处理，如需精确到各个方向可处理paddingLeft、paddingTop等）
      //       const padding = styles.padding
      //       if (padding) {
      //         const num = parseFloat(padding)
      //         if (!isNaN(num)) {
      //           styles.padding = num * 0.75 + 'px'
      //         }
      //       }
      //       // 同理处理height、fontSize等其他尺寸相关属性
      //     })
      //   }
      // }

    });
    return {
      showCompoents: showCompoents
    };
  }
};